module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAVVJREFUWEftlj9OwzAYR9+XNamUjWuUlTaiR+AGkBt0Yy0jW4/QI8AJ2qrNHI7QlQmkJmuMUojkRs4/B1EJJZMj2X5PP9ufLVz4kwvzGQSGBHol4EaM0wlvfTaynUCM76WsBcbA6jgltJXoLvAD5xteHCNriW4CGrwYqHpKtBfQYteg6G2b5WgncL7mZ1CleBfhStsDnZajWaAEz0GZ4tkRHvO2UmxFOAD3NhL1Aia4EErGQYR1IZAEzEZ7VjYS1QIV8HTCytsxKwvkMjYSlQLejo0It0WsmRDm8Py/SsAkoY8z1QqzQIw/SvkwwZsEyhJK8ZQELKoKVWUC7p65wIM4LI43vOgT1CVQ9PMilqLwjy5zrvnsLFBXWtsItC3NzcfQMNMgMCQwJDAkkD9GHUV8ug3hNZly17bwlPtZFaLTfRCxJDu9CxdJwObPBWyBv5bAvxH4Amz/wCFOFq5tAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/chart_up_arrow.png
// module id = 8jSD
// module chunks = 3